let GroupType = {
    DEFAULT: 'default',
    KMO: 'kmo',
    WELLNESS: 'wellness'
};

export default GroupType